// ChangePasswordDialog/index.js
import { connect } from 'react-redux';
import ChangePasswordDialog from '../../components/ChangePasswordDialog';

import {
  openChangePasswordDialogDispatch,
  changePasswordDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    openDialog: state.users.openChangePasswordDialog,
    user: state.users.userInAuth0.item,
    isSaving: state.users.changePasswordRequest.isSaving
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onOpenChangePasswordDialog: (open) => {
      dispatch(openChangePasswordDialogDispatch(open));
    },
    onChangePassword: (userEmail) => {
      dispatch(changePasswordDispatch(userEmail));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePasswordDialog);
